import { combineReducers } from 'redux';
import { 
    authLoginReducer, 
    authRegisterReducer,
    authInfoReducer, 
    authUpdateProfileReducer,
    singleUserDetailsReducer,
    singleUserUpdateReducer,
    singleUserDeleteReducer,
    authUserReducer,
    authMakerReducer,
    authAdminReducer,
    getUserReportReducer,
    postUserReportReducer,
    getUserReportOneReducer,
    getUserReportDeleteReducer,
} from './AuthReducer';
import { cartReducer } from './CartReducer';
import { 
    productListReducer, 
    productDetailsReducer, 
    productDeleteReducer,
    productReviewCreateReducer,
    productCreateReducer,
    artisanProductsReducer,
    aProductDetailsReducer,
    productApprovedReducer,
    artisanProductApprovedReducer,
    approvedProductListReducer,
    productFilterListReducer
} from './ProductReducer';
import { 
    artisanOrderListReducer,
    createRazorpayOrderReducer, 
    loggedUserOrderReducer, 
    orderCreateReducer, 
    orderDeliverReducer, 
    orderDetailsReducer, 
    orderListReducer, 
    orderPayReducer 
} from './OrderReducer';

import { 
    artisanProductCreateReducer,
    artisanProductDeleteReducer,
    artisanProductDetailsReducer, 
    artisanProductListReducer 
} from './ArtisanReducer';
import { adminCountReducer, artisanCountReducer, artisanProductCountReducer, orderCountReducer, orderDeliveredCountReducer, orderPaidCountReducer, productCountReducer, userCountReducer, userReportCountReducer } from './CountReducer';


export const reducers = combineReducers({
    productList: productListReducer,
    productDetails: productDetailsReducer,
    productDelete: productDeleteReducer,
    productCreate: productCreateReducer,
    productApproved: productApprovedReducer,
    approvedProducts: approvedProductListReducer,
    productReviewCreate: productReviewCreateReducer,
    artisanProducts: artisanProductsReducer,
    artisanProductDetail: aProductDetailsReducer,
    artisanproductApproved: artisanProductApprovedReducer,
    productFilter: productFilterListReducer,

    auth: authInfoReducer,
    authLogin: authLoginReducer,
    authRegister: authRegisterReducer,
    authUpdateProfile: authUpdateProfileReducer,

    userList: authUserReducer,
    makerList: authMakerReducer,
    adminList: authAdminReducer,
    authDetails: singleUserDetailsReducer,
    authUpdate: singleUserUpdateReducer,
    authDelete: singleUserDeleteReducer,

    userReport: postUserReportReducer,
    userReportList: getUserReportReducer,
    userReportDetails: getUserReportOneReducer,
    userReportDelete: getUserReportDeleteReducer,
    
    cart: cartReducer,
    
    orderCreate: orderCreateReducer,
    myOrder: loggedUserOrderReducer,
    orderDetails: orderDetailsReducer,
    razorpayOrder: createRazorpayOrderReducer,
    orderPay: orderPayReducer,
    orderDelivered: orderDeliverReducer,
    orderList: orderListReducer,
    artisanOrderList: artisanOrderListReducer,


    artisanProductList: artisanProductListReducer,
    artisanProductDetails: artisanProductDetailsReducer,
    artisanProductDelete: artisanProductDeleteReducer,
    artisanProductCreate: artisanProductCreateReducer,


    userCount: userCountReducer,
    artisanCount: artisanCountReducer,
    adminCount: adminCountReducer,
    productCount: productCountReducer,
    artisanProductCount: artisanProductCountReducer,
    orderCount: orderCountReducer,
    orderPaidCount: orderPaidCountReducer,
    orderDeliveredCount: orderDeliveredCountReducer,
    userReportCount: userReportCountReducer
})